import { useEffect, useState } from 'react';
import Button from '../../../../../components/Button';
import Input from '../../../../../components/Input';
import Modal from '../../../../../components/Modal'
import styles from './style.module.scss';
import { ListItem } from '../../../../../store/signUp/types';
import { useDispatch, useSelector } from '../../../../../store/store';
import { selectExpertsList, selectSkillsList } from '../../../../../store/signUp/selectors';
import { getExpertiesThunk, getSkillsThunk } from '../../../../../store/signUp/thunks';
import Tag from '../../../../../components/Tag';
import { setAddExpertiseModal, setSelectedExpertise } from '../../../../../store/workspace/slice';
import { updateProfileDataThunk } from '../../../../../store/workspace/thunks';
import { Expert } from '../../../../../store/workspace/types';
import {
    selectProfileData,
    selectExpertiseEditMode,
    selectSelectedExpertise,
    selectUpdatingProfileData,
} from '../../../../../store/workspace/selectors';

const defaultExpert = { id: -1, title: '', orderId: 0 };

export default function AddExpertise() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfileData);
    const skillsList = useSelector(selectSkillsList);
    const [skillTitle, setSkillTitle] = useState('');
    const expertsList = useSelector(selectExpertsList);
    const editMode = useSelector(selectExpertiseEditMode);
    const isLoading = useSelector(selectUpdatingProfileData);
    const [customSkillIndx, setCustomSkillIndx] = useState(-1);
    const selectedExpertise = useSelector(selectSelectedExpertise);
    const [skills, setSkills] = useState<ListItem[]>(selectedExpertise?.skills || []);
    const [expert, setExpert] = useState<Expert>(selectedExpertise?.expert || defaultExpert);

    useEffect(() => {
        dispatch(getSkillsThunk());
        dispatch(getExpertiesThunk());

        return () => {
            dispatch(setSelectedExpertise(null));
        }
    }, []);

    const addSkill = (item: ListItem) => {
        setSkillTitle('');
        setCustomSkillIndx(prev => prev - 1);

        const list = [...skills, item].sort((a, b) => a.title.length - b.title.length)
        setSkills([...new Set(list)]);
    };

    const removeSkill = (id: number) => {
        setSkills(prev => prev.filter(i => i.id !== id));
    };

    const submit = () => {
        if (!profile) return;
        const { kyc, matchedJobs, setting, ...rest } = profile;

        if (editMode) {
            const filteredList = profile.experties.filter(i => i.expert.id !== selectedExpertise?.expert.id);
            const record = { expert, skills };

            dispatch(updateProfileDataThunk({
                ...rest,
                experties: [...filteredList, record]
            }));
        } else {
            let maxOrder = 0;
            if (profile.experties.length > 0) {

                const orders = profile.experties.map(i => i.expert.orderId);
                maxOrder = Math.max(...orders);
            }

            const newRecord = { expert: { ...expert, orderId: maxOrder }, skills };
            dispatch(updateProfileDataThunk({
                ...rest,
                experties: [...profile.experties, newRecord]
            }));
        }
    };

    return (
        <Modal
            size='md'
            childClassName={styles.wrapper}
            title={editMode ? 'Edit expertise' : 'Add expertise'}
            closeFunc={() => dispatch(setAddExpertiseModal(false))}
        >
            <Input
                listShow
                type='text'
                listIdKey='id'
                label='Expertise'
                value={expert.title}
                listTitleKey='title'
                placeholder='EX: Software engineer'
                onItemClick={(item: Expert) => setExpert(item)}
                onChange={(val: string) => setExpert({ id: -1, title: val, orderId: 0 })}
                list={expertsList.filter(i => i.title.toLowerCase().startsWith(expert.title.toLowerCase()))}
            />
            <span className={styles.skills_label}>Your Skills</span>
            <div className={styles.skills}>
                <div className={styles.skills_action}>
                    <Input
                        listShow
                        type='text'
                        listIdKey='id'
                        value={skillTitle}
                        listTitleKey='title'
                        onChange={setSkillTitle}
                        placeholder='Enter skill or select from list'
                        onItemClick={(item: ListItem) => addSkill(item)}
                        wrapperClassName={styles.skills_action_input}
                        list={skillsList.filter(i => i.title.toLowerCase().startsWith(skillTitle.toLowerCase()))}
                    />
                    <Button
                        text='+'
                        type='Outline-Primary'
                        disabled={!skillTitle}
                        onClick={() => addSkill({ id: customSkillIndx, title: skillTitle })}
                    />
                </div>
                <div className={styles.skills_box}>
                    {skills.map(item => <Tag
                        key={item.id}
                        title={item.title}
                        action={() => removeSkill(item.id)}
                    />)}
                </div>
            </div>
            <Button
                text='Save'
                onClick={submit}
                loading={isLoading}
                disabled={!expert.title}
                className={styles.next}
            />
        </Modal>
    )
}
